module.exports = __webpack_public_path__ + "static/media/Portrait-10021.f4a302ae.jpg";